'use client';
import { useCallback, useRef } from 'react';
/** One VBC visit and stable event IDs across bounded transport retries. No sensitive values. */
export function usePublicVbcActions(endpoint, businessProfileId, getHeaders, surface = 'vendor_detail') {
    const visit = useRef(null);
    const key = `${endpoint}:${businessProfileId}`;
    return useCallback((action) => {
        if (!endpoint)
            return;
        if (visit.current?.key !== key)
            visit.current = { key, id: crypto.randomUUID() };
        const body = JSON.stringify({ ...action, eventId: crypto.randomUUID(), operationId: visit.current.id, businessProfileId, surface, contractVersion: 1 });
        const send = async () => {
            let verifiedHeaders;
            try {
                verifiedHeaders = await getHeaders?.() ?? {};
            }
            catch {
                return;
            }
            const headers = { 'Content-Type': 'application/json', ...verifiedHeaders };
            for (let attempt = 0; attempt < 2; attempt++) {
                try {
                    const response = await fetch(endpoint, { method: 'POST', headers, body, keepalive: true });
                    if (response.ok || response.status < 500)
                        return;
                }
                catch { /* Retry once with the same event ID. */ }
            }
        };
        void send();
    }, [endpoint, businessProfileId, key, getHeaders, surface]);
}
